<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import {BIconCaretLeftFill, BIconCaretRightFill, BIconExclamationCircleFill} from 'bootstrap-vue'
import systemCode from "@/mixins/systemCode";
import router from "@/mixins/router";
import listDailyReport from "@/mixins/daily_reports/listDailyReport";
import ModalWorkHistory from "@/views/pages/daily_reports/modals/ModalWorkHistory.vue";
import VendorsName from '@/views/pages/daily_reports/components/vendors_name.vue';
import VendorsAddress from '@/views/pages/daily_reports/components/vendors_address.vue';
import VendorSitesName from '@/views/pages/daily_reports/components/vendor_sites_name.vue';
import VendorSitesAddress from '@/views/pages/daily_reports/components/vendor_sites_address.vue';
import Cars from '@/views/pages/daily_reports/components/cars.vue';
import Staffs from '@/views/pages/daily_reports/components/staffs.vue';
import user from "@/mixins/user";
import DatePicker from "vue2-datepicker";

export default {
  name: "ListDailyReport",
  page: {
    title: "作業日報一覧（運搬）",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [systemCode, router, listDailyReport, user],
  components: {
    Layout,
    BIconExclamationCircleFill,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    ModalWorkHistory,
    VendorsName,
    VendorsAddress,
    VendorSitesName,
    VendorSitesAddress,
    Cars,
    Staffs,
    DatePicker,
  },
  data() {
    return {
      screens: this.$constant.screens,
    }
  },
  methods:{
    onChangeSelectedDate(){
      this.getData();
    },
  },
};
</script>
<template>
  <Layout>
    <ModalWorkHistory
      ref="workHistory"
    />
    <b-card class="mb-1">
      <div class="d-flex justify-content-center mb-2">
        <div class="fw-bold">
          <span class="h4 mb-2 cursor-pointer">
            <b-icon-caret-left-fill variant="primary" @click="prevDate" v-if="showPrev"/>
          </span>
          </div>
          <div>
          <date-picker
                lang="ja"
                :clearable="false"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD（ddd）"
                value-type="YYYY-MM-DD"
                position="left"
                type="date"
                v-model="filters.date"
                @change="onChangeSelectedDate"
              >
            </date-picker>
            </div><div>
          <span class="h4 mb-2 cursor-pointer">
            <b-icon-caret-right-fill variant="primary" @click="nextDate" v-if="showNext"/>
          </span>
        </div>
        <div>
        <b-button variant="primary" size="lg" class="mx-5"
                  @click="
              redirectRoute(
                'factories',
                {},
                { fromMenu: 0, date: filters.date }
              )
            "
                  v-if="showSelectFactory"
        >
          工場選択
        </b-button>
        </div>
      </div>
    </b-card>
    <b-card v-for="(item, index) in data" :key="index">
      <b-row :id="`schedule_${index + 1}`">
        <b-row class="mb-2">
          <b-col cols="3">
            <div class="d-flex">
              <span class="badge mr-0dot5" :class="item.schedule && item.schedule.is_mixed_loading_kbn ? 'bg-primary' : 'orange'">{{ item.schedule && item.schedule.is_mixed_loading_kbn ? "合積" : "単独"}}</span>
              <span class="badge mr-0dot5" :style="{'background-color': colorBadge5(item)}">{{ showBadge5(item) }}</span>
              <span class="badge" :style="{ backgroundColor: getColorBadge6(item, index) + '!important', color:getColorTextBadge6(item, index)}">{{ showBadge6(item) }}</span>
            </div>
          </b-col>
          <b-col cols="6">
            <template v-if="showDateAlert(item)">
              <span class="h3">
                <b-icon-exclamation-circle-fill variant="danger"/>
              </span>
              <span>
                {{ formatDateAlert(item) }}
              </span>
            </template>
          </b-col>
          <b-col cols="3">
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-primary w-md waves-effect waves-light mr-0dot5"
                @click="
              redirectRoute(
                'daily_reports.input',
                { id: item.id },
                { index: index + 1, date: filters.date }
              )
            "
              >
                日報入力
              </button>
              <button
                @click="openworkHistoryModal(item)"
                class="btn btn-primary waves-effect waves-light"
              >
                <i class="fas fa-history"></i> 作業履歴
              </button>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="1">
            <div class="wrapC">
              <div class="labelC">No</div>
              <div class="contentC">{{ index + 1 }}</div>
            </div>
          </b-col>
          <b-col cols="2">
            <div class="wrapC">
              <div class="labelC">受付番号</div>
              <div class="contentC"><span>{{ item.schedule_id }}</span></div>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="wrapC">
              <div class="labelC">作業指示名</div>
              <div class="contentC"><span>
              <router-link
                v-if="item.work_order_json && item.work_order_json.case"
                :to="{ name: 'projects.sales.instructions.detail', params: { id: item.work_order_json.case.id, work_order_id: item.work_order_json.id  }, query: { readonly: true, daily_report_id: item.id } }"
              >
                {{ item.work_order_json.name }}
              </router-link>
            </span></div>
            </div>
          </b-col>
          <b-col cols="4">
            <div class="wrapC fw-bold">
              <div class="labelC">作業日時</div>
              <div class="contentC"><span v-if="item.schedule">{{ formatHour(item.schedule.start_datetime) }}</span></div>
              <div class="mt-2">～</div>
              <div class="contentC "><span v-if="item.schedule">{{ formatHour(item.schedule.end_datetime) }}</span></div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <div class="wrapC">
              <div class="labelC blue">排出事業者</div>
              <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">{{ item.work_order_json.case.discharger.name }}</span></div>
            </div>
            <div class="wrapC">
              <div class="labelC blue">排出事業場</div>
              <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">{{ item.work_order_json.case.discharger_site.name }}</span></div>
            </div>
            <div class="wrapC" v-if="showProcessCompany(item)">
              <div class="labelC green">処分事業者</div>
              <VendorsName
                v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
              />

              </div>
              <div class="wrapC" v-if="showProcessCompany(item)">
                <div class="labelC green">処分事業場</div>
                <VendorSitesName
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
              <div class="wrapC" v-if="item.schedule && item.schedule.assigned_cars_by_schedule">
                <div class="labelC green">車両</div>
                <Cars
                  v-if="item.schedule && item.schedule.assigned_cars_by_schedule"
                  :schedule="item.schedule"
                />
              </div>
            </b-col>
            <b-col cols="6">
              <div class="wrapC">
                <div class="labelC">排出事業者住所</div>
                <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">
                  {{
                    $helpers.formatZipCode(item.work_order_json.case.discharger.zip)
                    + (item.work_order_json.case.discharger.address_1 === null ? '' : item.work_order_json.case.discharger.address_1)
                    + (item.work_order_json.case.discharger.address_2 === null ? '' : item.work_order_json.case.discharger.address_2)
                    + (item.work_order_json.case.discharger.address_3 === null ? '' : item.work_order_json.case.discharger.address_3)
                    + (item.work_order_json.case.discharger.address_4 === null ? '' : item.work_order_json.case.discharger.address_4)
                  }}
                </span></div>
              </div>
              <div class="wrapC">
                <div class="labelC">排出事業場住所</div>
                <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">
                  {{
                    $helpers.formatZipCode(item.work_order_json.case.discharger_site.zip)
                    + (item.work_order_json.case.discharger_site.address_1 === null ? '' : item.work_order_json.case.discharger_site.address_1)
                    + (item.work_order_json.case.discharger_site.address_2 === null ? '' : item.work_order_json.case.discharger_site.address_2)
                    + (item.work_order_json.case.discharger_site.address_3 === null ? '' : item.work_order_json.case.discharger_site.address_3)
                    + (item.work_order_json.case.discharger_site.address_4 === null ? '' : item.work_order_json.case.discharger_site.address_4)
                  }}
                </span></div>
              </div>
              <div class="wrapC" v-if="showProcessCompany(item)">
                <div class="labelC">処分事業者住所</div>
                <VendorsAddress
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
              <div class="wrapC" v-if="showProcessCompany(item)">
                <div class="labelC">処分事業場住所</div>
                <VendorSitesAddress
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  :wastes-or-service-by-schedule="item.schedule.waste_or_services_by_schedule"
                />
              </div>
              <div class="wrapC" v-if="item.schedule && item.schedule.assigned_staffs_by_schedule">
                <div class="labelC">従業員</div>
                <Staffs
                  v-if="item.schedule && item.schedule.assigned_staffs_by_schedule"
                  :schedule="item.schedule"
                />
              </div>

            </b-col>
          </b-row>
          <b-row v-if="showProcessCompany(item)">
            <b-col>
              <div class="wrapC">
                <div class="labelC">作業者向け備考欄 </div>
                <div class="contentC"><span
                  v-if="item.schedule && item.schedule.waste_or_services_by_schedule"
                  v-html="getCommentToUser(item.schedule.waste_or_services_by_schedule)">
                </span></div>
              </div>
            </b-col>
          </b-row>
        </b-row>
      </b-card>
  </Layout>
</template>
<style lang="scss" scoped>
.labelC {
  padding: 10px;
  white-space:nowrap;
  font-weight: bold;
}
.contentC {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
.wrapC {
  margin-bottom: 10px;
  display: flex;
  column-gap: 0.5rem !important;
}
.blue {
  background: #92c4e7;
}
.green {
  background: #a6ddcb;
}
.badge {
  width: 100%;
  padding: 10px;
}
.orange {
  background: #d1885d!important;
}
.grey {
  background: #f8f9fa;
}
.w-3 {
  width: 30%;
}
.mr-0dot5 {
  margin-right: 5px;
}
</style>
